import { CmsObjectWithDefault } from '@components/Cms/types';

export type LogoCmsKey = 'LogoAlt';

export const LogoCmsWithDefault: CmsObjectWithDefault<LogoCmsKey> = {
    LogoAlt: {
        cmsId: 223452,
        defaultTranslation: 'travel portal logo',
    },
};
